<template>
    <q-dialog
        v-model="returnOrder"
        :maximized="$q.platform.is.mobile">
        <q-card class="modal-refund">
            <div class="modal-header">
                <span class="modal-title">Возврат - Заказ №{{ orderId }}</span>
                <div class="modal-close" @click="returnOrder=false">
                    <span aria-hidden="true">
                        <svg version="1.1" id="" xmlns="http://www.w3.org/2000/svg" xmlns:xli.nav-itemnk="http://www.w3.org/1999/xli.nav-itemnk" x="0px" y="0px" width="10px" height="10px" viewBox="0 0 10 10" enable-background="new 0 0 10 10" xml:space="preserve">
                            <path fill="" d="M5.429,5l4.478-4.472c0.116-0.118,0.116-0.31,0-0.428c-0.119-0.118-0.31-0.118-0.429-0.001L5,4.571 L0.522,0.099C0.404-0.019,0.212-0.018,0.093,0.1c-0.117,0.118-0.117,0.31,0,0.428L4.571,5L0.094,9.471 c-0.117,0.118-0.117,0.31,0,0.427c0.06,0.062,0.138,0.09,0.215,0.09c0.078,0,0.154-0.028,0.214-0.088L5,5.428l4.479,4.473 c0.059,0.06,0.137,0.088,0.215,0.088c0.076,0,0.155-0.028,0.214-0.09c0.116-0.117,0.116-0.309,0-0.427L5.429,5z"></path>
                        </svg>
                    </span>
                </div>
            </div>
            <q-card-section class="modal-content scroll" style="max-height: 80vh">
                <div class="row q-col-gutter-md">
                    <div class="col-12 col-md-8">
                        <q-select
                            dense
                            square
                            outlined
                            hide-selected
                            fill-input
                            use-input
                            input-debounce="0"
                            v-model="refundType"
                            :options="refundTypes"
                            :options-dense="true"
                            option-value="slug"
                            option-name="label"
                            emit-value
                            map-options
                            :error-message="form.errors.get('refund_type')"
                            :error="form.errors.has('refund_type')"
                            label="Способ возврата">
                        </q-select>
                        <div v-if="refundType === 'post'">
                            <q-input
                                dense
                                square
                                outlined
                                :value="form.receiver"
                                @input="setValue('receiver', $event)"
                                :error-message="form.errors.get('receiver')"
                                :error="form.errors.has('receiver')"
                                label="Получатель" />
                            <q-input
                                dense
                                square
                                outlined
                                :value="form.email"
                                @input="setValue('email', $event)"
                                :error-message="form.errors.get('email')"
                                :error="form.errors.has('email')"
                                label="E-mail" />
                            <div v-if="useRegion" class="">
                                <q-select
                                    clearable
                                    dense
                                    square
                                    outlined
                                    hide-selected
                                    use-input
                                    input-debounce="0"
                                    :value="form.region.id"
                                    @input="setRegion"
                                    option-value="id"
                                    option-name="label"
                                    :options="regionOptions"
                                    :options-dense="true"
                                    @filter="searchRegion"
                                    emit-value
                                    map-options
                                    :error-message="form.errors.get('region.name')"
                                    :error="form.errors.has('region.name')"
                                    label="Регион">
                                </q-select>
                            </div>
                            <q-select
                                clearable
                                dense
                                square
                                outlined
                                fill-input
                                hide-selected
                                use-input
                                input-debounce="0"
                                :value="form.city.id"
                                @input="setCity"
                                option-value="id"
                                option-label="label"
                                :options="cityOptions"
                                :options-dense="true"
                                @filter="searchCity"
                                emit-value
                                map-options
                                :label="useRegion ? 'Введите город/посёлок' : null"
                                :error-message="form.errors.get('city.name')"
                                :error="form.errors.has('city.name')"
                                class="mb-4">
                                <template v-slot:no-option>
                                    <!--<q-item>
                                        <q-item-section>
                                            {{ noCityResults ? 'Ничего не найдено' : 'Введите первые буквы поиска' }}
                                        </q-item-section>
                                    </q-item>-->
                                </template>
                                <template v-slot:selected-item="scope">
                                    {{ scope.name }}
                                </template>

                                <template v-slot:hint>
                                    <span class="link" @click.prevent="useRegion = true" v-if="!useRegion">Моего города нет в списке</span>
                                </template>

                            </q-select>
                            <q-select
                                clearable
                                dense
                                square
                                outlined
                                hide-selected
                                fill-input
                                use-input
                                input-debounce="0"
                                :value="form.street.id ? form.street.id : form.street.name"
                                @input-value="setStreet"
                                @clear="setStreet('')"
                                option-value="id"
                                option-name="label"
                                :options="streetOptions"
                                :options-dense="true"
                                @filter="searchStreet"
                                emit-value
                                map-options
                                hide-dropdown-icon
                                :error-message="form.errors.get('street.name')"
                                :error="form.errors.has('street.name')"
                                label="Улица">
                            </q-select>


                            <div class="row q-col-gutter-md">
                                <div class="col-12 col-md-4">
                                    <q-select
                                        clearable
                                        dense
                                        square
                                        outlined
                                        fill-input
                                        hide-selected
                                        use-input
                                        input-debounce="0"
                                        :value="form.house"
                                        @input-value="setHouse"
                                        @clear="setHouse('')"
                                        option-value="id"
                                        option-name="label"
                                        :options="houseOptions"
                                        :options-dense="true"
                                        @filter="searchHouse"
                                        emit-value
                                        map-options
                                        hide-dropdown-icon
                                        :error-message="form.errors.get('house')"
                                        :error="form.errors.has('house')"
                                        label="Дом">
                                    </q-select>
                                </div>
                                <div class="col-12 col-md-4">
                                    <q-input
                                        dense
                                        square
                                        outlined
                                        use-input
                                        :value="form.flat"
                                        @input="setValue('flat', $event)"
                                        :error-message="form.errors.get('flat')"
                                        :error="form.errors.has('flat')"
                                        label="Квартира" />
                                </div>
                                <div class="col-12 col-md-4">
                                    <q-input
                                        dense
                                        square
                                        outlined
                                        use-input
                                        :value="form.zip"
                                        @input="setValue('zip', $event)"
                                        :error-message="form.errors.get('zip')"
                                        :error="form.errors.has('zip')"
                                        label="Индекс" />
                                </div>
                            </div>
                        </div>
                        <div v-if="refundType === 'bank'">
                            <q-input
                                dense
                                square
                                outlined
                                :value="form.account_owner"
                                @input="setValue('account_owner', $event)"
                                :error-message="form.errors.get('account_owner')"
                                :error="form.errors.has('account_owner')"
                                label="Владелец счёта"/>
                            <q-input
                                dense
                                square
                                outlined
                                :value="form.email"
                                @input="setValue('email', $event)"
                                :error-message="form.errors.get('email')"
                                :error="form.errors.has('email')"
                                label="E-mail" />
                            <q-input
                                dense
                                square
                                outlined
                                :value="form.bik"
                                @input="setValue('bik', $event)"
                                :error-message="form.errors.get('bik')"
                                :error="form.errors.has('bik')"
                                label="БИК" />
                            <q-input
                                dense
                                square
                                outlined
                                :value="form.bank_inn"
                                @input="setValue('bank_inn', $event)"
                                :error-message="form.errors.get('bank_inn')"
                                :error="form.errors.has('bank_inn')"
                                label="ИНН банка" />
                            <q-input
                                dense
                                square
                                outlined
                                :value="form.bank_name"
                                @input="setValue('bank_name', $event)"
                                :error-message="form.errors.get('bank_name')"
                                :error="form.errors.has('bank_name')"
                                label="Банк" />
                            <q-input
                                dense
                                square
                                outlined
                                :value="form.correlation_account"
                                @input="setValue('correlation_account', $event)"
                                :error-message="form.errors.get('correlation_account')"
                                :error="form.errors.has('correlation_account')"
                                label="Кор. счёт" />
                            <q-input
                                dense
                                square
                                outlined
                                :value="form.payment_account"
                                @input="setValue('payment_account', $event)"
                                :error-message="form.errors.get('payment_account')"
                                :error="form.errors.has('payment_account')"
                                label="Расчётный счёт" />
                            <q-input
                                dense
                                square
                                outlined
                                :value="form.personal_account"
                                @input="setValue('personal_account', $event)"
                                :error-message="form.errors.get('personal_account')"
                                :error="form.errors.has('personal_account')"
                                label="Лицевой счёт" />
                            <q-input
                                dense
                                square
                                outlined
                                :value="form.card_number"
                                @input="setValue('card_number', $event)"
                                :error-message="form.errors.get('card_number')"
                                :error="form.errors.has('card_number')"
                                label="Номер карты" />
                        </div>
                    </div>

                    <div class="col-12 col-md-4">
                        <div class="refund-total">
                            <div v-for="item in returnItems" class="item">
                                <div class="item-title">
                                    {{ orderItem(item).primary_category }}
                                    {{ orderItem(item).brand }}
                                </div>
                                <div class="item-price">{{ $root.priceFormat(orderItem(item).sale_price) }} &#8381;</div>
                                <div class="item-reason">
                                    <span>Причина возврата: </span>
                                    <p v-if="item.reasonKey === 'size'">Не подошёл размер</p>
                                    <p v-if="item.reasonKey === 'style'">Не понравился стиль</p>
                                    <p v-if="item.reasonKey === 'defekt'">Обнаружен дефект</p>
                                    <p v-if="item.reasonKey === 'other'">{{ item.reason}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="refund-features">
                            <div class="refund-features-img"><img src="/images/svg/clock.png" alt=""></div>
                            <p>Срок перевода составляет не более 10 дней с даты поступления товара на склад.</p>
                        </div>
                        <div v-if="form.refund_type === 'bank'" class="refund-features">
                            <div class="refund-features-img"><img src="/images/svg/blank_order.png" alt=""></div>
                            <div>
                                <p>БИК банка всегда состоит из 9 цифр.</p>
                                <p>Если в ваших реквизитах указан счёт, начинающийся на 40817, впишите его в графу
                                    Лицевой счёт.</p>
                                <p>В случае, если в реквизитах указан расчётный счёт банка, начинающийся на
                                    30232810, его нужно вписать в графу Расчётный счёт, а номер лицевого счёта или
                                    карты в соответствующие графыю</p>
                            </div>
                        </div>
                    </div>
                </div>

                <q-item tag="label" v-ripple>
                    <q-item-section avatar top>
                        <q-checkbox v-model="check"
                                    :error-message="form.errors.get('check')"
                                    :error="form.errors.has('check')" />
                    </q-item-section>
                    <q-item-section>
                        <q-item-label caption> Настоящим, в соответствии с ч. 2 ст. 158 ГУ РФ, я даю ООО «АДС»
                            предварительное согласие на обработку и использрвание моих персональных данных, согласно
                            ст. 3 ФЗ "О персональных данных" от 27.07.2006, в целях, определённых Уставом Оператора,
                            без ограничения срока действия. Согласно п. 5 ст. 21 Закона, настоящее согласие может
                            быть отозвано только при условии письменного уведомления Оператора не менее чем за 180
                            дней до предполагаемой даты прекращения использования данных Оператором.</q-item-label>
                    </q-item-section>
                </q-item>
                <q-card-actions align="right">
                    <q-btn color="primary" label="Оформить" @click.prevent="postReturnOrder" />
                </q-card-actions>
            </q-card-section>
        </q-card>
    </q-dialog>
</template>

<script>
    import location from './../../mixins/location';
    import { mapState, mapMutations, mapActions } from 'vuex';

    export default {
        name: 'Return',
        mixins: [
            location,
        ],
        props: {
            //
        },
        data: function () {
            return {
                refundTypes: [
                    {
                        slug: 'post',
                        label: 'Почтовый перевод',
                    },
                    {
                        slug: 'bank',
                        label: 'Банковский перевод',
                    },
                ]
            }
        },
        mounted: function () {
            //
        },
        watch: {
            //
        },
        methods: {
            ...mapMutations('customer', [
                'setReturnOrderFormValue',
            ]),

            ...mapActions('customer', [
                'postReturnOrder',
            ]),

            getLocationForm () {
                return this.form;
            },

            setLocationFormValue (key, value) {
                this.setValue(key, value);
            },

            setValue (key, value) {
                this.setReturnOrderFormValue({
                    key: key,
                    value: value
                });
            },

            orderItem (item) {
                let order = this.orders.data.find(order => order.id === item.orderId);

                if (order) {
                    return order.items.find(orderItem => orderItem.id === item.itemId);
                }

                return null;
            }
        },
        computed: {
            ...mapState('customer', {
                orders: 'orders',
                form: 'returnOrderForm'
            }),

            orderId: {
                get () {
                    return this.$store.state.customer.returnOrder;
                },
                set (value) {
                    //
                }
            },

            returnOrder: {
                get() {
                    return !!this.$store.state.customer.returnOrder;
                },
                set(value) {
                    this.$store.commit('customer/returnOrder', value);
                }
            },
            returnItems: {
                get () {
                    return this.$store.state.customer.returnProducts.filter(item => item.orderId === this.$store.state.customer.returnOrder);
                },
                set (value) {
                    //
                }
            },
            refundType: {
                get () {
                    return this.form.refund_type;
                },
                set (value) {
                    this.$store.commit('customer/setReturnOrderFormValue', {
                        key: 'refund_type',
                        value: value
                    })
                }
            },
            check: {
                get () {
                    return this.form.check;
                },
                set (value) {
                    this.$store.commit('customer/setReturnOrderFormValue', {
                        key: 'check',
                        value: value
                    })
                }
            }
        }
    }
</script>
